













import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class DoKoCardBlanko extends Vue {
  @Prop({
    type: String,
    default: "#ff6c6c",
  })
  private backgroundColor!: string;

  @Prop({
    type: String,
    default: "#f9f9f9",
  })
  private borderColor!: string;

  @Prop({
    type: Number,
    default: 5,
  })
  private borderWidth!: number;

  @Prop({
    type: Number,
    default: 40,
  })
  private radius!: number;

  get style() {
    return {
      opacity: 1,
      fillOpacity: 1,
      fillRule: "evenodd",
      fill: this.backgroundColor,
      stroke: this.borderColor,
      strokeWidth: this.borderWidth,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
    };
  }

  get offset() {
    return this.borderWidth / 2;
  }

  /*
  get backgroundColor() {
    return this.back ? "#ff6c6c" : "#fff";
  }
*/
}
